import React from "react";
import "./Intro.css";

export default () =>
  <div className="Intro">
    I am a <strong>London</strong> based <strong>developer</strong> of{" "}
    <strong>applications</strong>, <strong>sites</strong> and{" "}
    <strong>games</strong>.
  </div>;



// WEBPACK FOOTER //
// ./src/components/Intro.js